import React from "react";
import { Link } from "react-router-dom";
import { FaTiktok, FaPaypal, FaCcStripe, FaCcVisa, FaCcMastercard, FaCcAmex } from "react-icons/fa";
import { SiKlarna, SiAfterpay } from "react-icons/si";

export default function Footer({ tiktokHandle }) {
  const tiktokUrl = tiktokHandle ? `https://www.tiktok.com/@${tiktokHandle}` : "#";
  return (
    <footer data-testid="site-footer" className="bg-brand-ink text-brand-bg mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif text-3xl">cindymaks Collections</div>
          <p className="mt-4 text-sm leading-relaxed text-brand-bg/70 max-w-md">
            Hand-tailored African Ankara clothing. Each piece is cut, sewn, and finished with care — designed to be worn boldly and kept forever.
          </p>
          <a
            href={tiktokUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-tiktok-link"
            className="inline-flex items-center gap-2 mt-6 text-sm tracking-[0.2em] uppercase hover:text-brand-accent transition-colors"
          >
            <FaTiktok /> Follow on TikTok
          </a>
        </div>
        <div>
          <div className="overline text-brand-accent">Shop</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-brand-accent">All Collection</Link></li>
            <li><Link to="/about" className="hover:text-brand-accent">Our Story</Link></li>
            <li><Link to="/admin/login" className="hover:text-brand-accent">Admin</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-brand-accent">We accept</div>
          <div className="flex flex-wrap items-center gap-3 mt-4 text-2xl text-brand-bg/85">
            <FaCcVisa title="Visa" />
            <FaCcMastercard title="Mastercard" />
            <FaCcAmex title="Amex" />
            <SiKlarna title="Klarna" className="text-[#FFA8CD]" />
            <SiAfterpay title="Clearpay" />
            <FaPaypal title="PayPal" />
          </div>
          <p className="text-xs mt-3 text-brand-bg/60">Card · Klarna · Clearpay · PayPal · Cash on Delivery</p>
        </div>
      </div>
      <div className="border-t border-brand-bg/10 py-6 px-6 md:px-12 text-center text-xs text-brand-bg/60 tracking-wider">
        © {new Date().getFullYear()} cindymaks Collections. Made with love.
      </div>
    </footer>
  );
}
